import get from 'lodash.get';
/**
 * Takes all embeds that are larger than medium and not type markup and resizes them to medium
 * This is done here instead of restricting the embeds in the CMS
 * https://nbcnewsdigital.atlassian.net/browse/BENTO-19705
 * @param {Array} articleBody
 * @returns {Array}
 */
export const downsizeEmbeds = (articleBody) => articleBody.map((item) => {
  const type = get(item, 'type', null);
  const size = get(item, 'presentation.size', null);

  if (!type || type === 'markup') {
    return item;
  }

  if (!size || size === 'small' || size === 'medium') {
    return item;
  }

  return {
    ...item,
    presentation: {
      ...item.presentation,
      size: 'medium',
    },
  };
});
